import UserContext from '../context/context';
import { render, useContext } from '@wordpress/element';

const InFavor = () => {
  const context = useContext(UserContext);
  const { categories, geCat, forOpinion, getNextforOpinion, forCat } = context;

    return (
        <>
            <div class="graphic">
                <div class="left">
                    <h2>
                        Views of same-sex marriage and the percentage who...
                    </h2>
                </div>
                <div class="right">
                    <div class="image">
                        <img src="//assets.pewresearch.org/interactives/politics/2013/gay-marriage-changing-opinions/interactive-gaymarriage.png" />
                    </div>
                </div>
            </div>
            <div class="graphic border">
                <div class="left">
                    <h2>
                        Of the 14% who changed their mind and now favor gay
                        marriage, Pew Research asked...
                    </h2>
                    <p class="question">
                        What made you change your mind about same-sex marriage?
                    </p>
                    <div id="blockquote" class="filter1">
                        <div class="refresh" onClick={() => getNextforOpinion()}>Next Quote</div>
                        <p class="quote">
                            {forOpinion.opinion}
                        </p>
                        <p class="attribution">
                            - {forOpinion.gender}, {forOpinion.age} years old
                        </p>
                    </div>
                </div>
                <div class="right pie bars">
                    <p class="kicker">
                        Their responses could be categorized as...
                    </p>

                    {categories.map(category => (
                      <div onClick={(() => geCat(category.cat))} className={category.cat === forCat ? 'active' : ''}>
                        <div class="bar">{category.percentage}%</div>
                        <p>
                            {category.description}
                        </p>
                    </div>
                    ))}
                    
                    <p class="source textright">
                        Click a category above to see an opinion.
                        <br />
                        Numbers do not total 100% because of multiple responses.
                    </p>
                </div>
            </div>
        </>
    );
};

export default InFavor;
